import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { LEGAL_LINKS, EFFECTIVE_DATE, BUSINESS } from '@/lib/legal';

export default function LegalLayout({ title, intro, updated = true, children }) {
  return (
    <div className="min-h-screen bg-bone flex flex-col">
      <header className="sticky top-0 z-40 bg-bone/85 backdrop-blur-md border-b border-black/5">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-link" className="flex items-center">
            <img src="/logo-wordmark.png" alt={BUSINESS.legalName} className="h-9 object-contain" />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-charcoal/70 hover:text-saffron transition-colors duration-150"
          >
            <ArrowLeft size={16} /> Back to site
          </Link>
        </div>
      </header>

      <main className="flex-1 mx-auto max-w-3xl w-full px-5 sm:px-8 py-12 sm:py-16">
        <h1 className="font-heading font-900 tracking-tight text-charcoal text-4xl sm:text-5xl">{title}</h1>
        {updated && <p className="mt-3 text-sm text-muted-ink">Last updated: {EFFECTIVE_DATE}</p>}
        {intro && <p className="mt-4 text-lg text-muted-ink leading-relaxed">{intro}</p>}

        <div className="legal-content mt-8">{children}</div>

        <div className="mt-14 pt-8 border-t border-black/10">
          <p className="font-heading font-700 text-charcoal text-sm uppercase tracking-wide">More information</p>
          <div className="mt-4 flex flex-wrap gap-x-6 gap-y-2">
            {LEGAL_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`legal-nav-${l.to.slice(1)}`}
                className="text-sm text-coriander hover:underline"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </main>

      <footer className="bg-obsidian text-white/60">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-sm">
          <p>© {new Date().getFullYear()} {BUSINESS.legalName}</p>
          <div className="flex gap-4">
            <Link to="/cxlogin" data-testid="legal-footer-login" className="hover:text-white transition-colors duration-150">Log In</Link>
            <Link to="/register" data-testid="legal-footer-register" className="hover:text-white transition-colors duration-150">Register</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
